import { Component, OnInit } from '@angular/core';
import { ResultsService } from '../../../services/results.service';

@Component({
  selector: 'app-privacypolicy',
  templateUrl: './privacypolicy.component.html',
  styleUrls: ['./privacypolicy.component.css']
})
export class PrivacypolicyComponent implements OnInit {
  privacyContent:string="Your Privacy Policy Content Here";
  fileName: string = "Privacypolicy";
  interval:any;
  constructor(private resultservice: ResultsService) { }

  ngOnInit() {
    this.GetDefaultPrefernces();
    this.interval = setInterval(() => { 
        this.GetDefaultPrefernces(); 
    }, 10000);
  }
  GetDefaultPrefernces() {
    this.resultservice.getAllPreferences(this.fileName).then((result: any) => {
      if (result != null && result != '' && result != undefined) {
        this.privacyContent = result.content;
      }
    });
  }
}
